import { css } from '@emotion/css'
import { fontWeight, fontSize, spacing } from '../../../styles'
import getThemeColors, { colors } from '../../../themes'

const styles = {
  item: css({
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.2,
    fontWeight: fontWeight.regular,
    color: colors.jumbo,
    marginLeft: 0,

    '& > * + *': {
      marginLeft: spacing.default,
    },
  }),
}

export default styles

export const itemSize = size => {
  switch (size) {
    case 'extraSmall':
    case 'small':
      return css({
        fontSize: fontSize.small,
      })

    case 'medium':
    case 'large':
      return css({
        fontSize: fontSize.default,
      })

    default:
      return css({
        fontSize: fontSize.small,
      })
  }
}

export const iconColor = theme => {
  const themed = getThemeColors(theme)
  return themed.base
}

export const iconSize = size => {
  switch (size) {
    case 'extraSmall':
      return 14

    case 'small':
      return 16

    case 'medium':
      return 20

    case 'large':
      return 24

    default:
      return 18
  }
}
